export default __webpack_public_path__ + "static/media/gallery_07.2342fa58.jpg";